// extracted by mini-css-extract-plugin
module.exports = {"dividerContainer":"Divider_dividerContainer__EAbxd"};